
import {Component, Prop, Vue} from 'vue-property-decorator';
import {commitAddNotification} from '@/store/main/mutations';

@Component({})
export default class ShowObjectDialog extends Vue {
  @Prop()
  public objData!: any;

  private headers: any = [];
  private items: any = [];
  private search: string = '';

  private dialog: boolean = false;

  public async mounted() {
    this.headers = [];
    this.items = [];
    if (this.objData) {
      if (this.objData.headers) {

        this.objData.headers.forEach((e) => {
          this.headers.push({text: e, align: 'start', sortable: false, value: e});
        });
      }
      if (this.objData.values) {
        this.items = Object.assign(this.objData.values);
      }
    }
  }

  private downloadContentTable(): void {
    if (!this.objData) {
      commitAddNotification(this.$store,
          {color: 'warning', content: 'Não é possível baixar o conteúdo sem dados.'});
      return;
    }
  }

  private editFunction(item): void {
    if (this.headers) {
      const filtered = this.headers.find((e) => {
        return e.value === 'action';
      });
      if (filtered && filtered.router_name !== null) {
        this.$router.push({name: filtered.router_name, params: {id: item.id}});
      } else {
        console.log('Opção indisponível');
      }
    }
  }
}
